import _ from 'lodash';

import customMenus from './customMenus';
import { getNavsideIcon } from '../../utils/SideNavigationUtils';

const isValidDrawer = (drawer) => _.isObject(drawer) && _.isPlainObject(drawer);
const getCustomMenu = (id) => customMenus.find((cm) => cm.config.id === id);

export function processMenuItems(data, isArchiveMode, ARCHIVED_MODE_MENU_ITEMS, bottomMenuOrder) {
  return data
    .filter(({ Id }) => !(isArchiveMode && !ARCHIVED_MODE_MENU_ITEMS.includes(Id)))
    .sort((a, b) => {
      if (a.TopGroup !== b.TopGroup) {
        return a.TopGroup === true ? -1 : b.TopGroup === true ? 1 : 0;
      }
      return bottomMenuOrder.indexOf(b.Id) - bottomMenuOrder.indexOf(a.Id);
    })
    .map(({ Id, Text, Icon, contentInfos, NavigateURL, active }) => {
      const IconElement = getNavsideIcon(Icon);
      const customMenu = getCustomMenu(Id);
      const contentData = _.isNil(customMenu)
        ? _.get(contentInfos, ['menu', 'contentData'])
        : _.get(customMenu, ['config', 'contentInfos', 'menu', 'contentData']);
      const drawerIsValid = isValidDrawer(contentData);
      return {
        Id,
        text: Text,
        icon: IconElement,
        navigateURL: NavigateURL,
        active,
        contentData: drawerIsValid ? { ...contentData, Id } : null,
        'ui-ta': 'action',
        'data-testId': Id,
      };
    });
}
